import type { AlertVariant } from './Alert.types';

export const baseClasses = 'flex';

export const msgClasses = 'text-sm';

export const contentWrapperClasses = 'flex flex-col mt-3 mb-3 gap-y-2';

export const iconWrapperClasses = 'flex ml-3 mt-[14px] mb-3 mr-1';

export const dismissWrapperClasses = 'ml-auto p-2';

const commonBorderClasses = 'border-[1.5px] rounded-lg lumon:rounded-[4px]';

export const variantClasses: Record<AlertVariant, string> = {
  error: `bg-alert border-[rgb(192,0,10)] shadow-[0_4px_0_rgb(192,0,10)] lumon:bg-red-50 lumon:border-red-350 lumon:shadow-red-350 ${commonBorderClasses}`,
  info: `bg-info border-[rgb(23,22,108)] shadow-[0_4px_0_rgb(23,22,108)] lumon:bg-blue-50 lumon:border-blue-400 lumon:shadow-blue-400 ${commonBorderClasses}`,
  success: `bg-success border-[rgb(8,138,21)] shadow-[0_4px_0_rgb(8,138,21)] lumon:bg-green-50 lumon:border-green-350 lumon:shadow-green-350 ${commonBorderClasses}`,
  warning: `bg-warning border-[rgb(249,189,25)] shadow-[0_4px_0_rgb(249,189,25)] lumon:border-orange-300 lumon:bg-orange-50 lumon:shadow-orange-300 ${commonBorderClasses}`
};

export const variantIconClasses: Record<AlertVariant, string> = {
  error: `text-[rgb(192,0,10)] lumon:text-red-350`,
  info: `text-[rgb(23,22,108)] lumon:text-blue-400`,
  success: `text-[rgb(8,138,21)] lumon:text-green-350`,
  warning: `text-[rgb(249,189,25)] lumon:text-orange-300`
};
